// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"7bf75d5e","894":"1d1f8652"}[chunkId] + ".chunk.js";
};